/**
 * Modules
 */
import Vue from 'vue'
import store from '../store'
import Router from 'vue-router'
import _ from 'lodash'
// import t from '../translation'
/**
 * Composants
 */
import Dash from '../components/Dash'
import Login from '../components/Login'
import Dashboard from '../components/Dashboard'
import Trafic from '../components/Trafic'
import Visitors from '../components/trafic/Visitors'
import Chatting from '../components/trafic/Chatting'
import Monitoring from '../components/trafic/Monitoring'
import Attente from '../components/trafic/Attente'
import Contact from '../components/trafic/Contact'
import Stats from '../components/Stats'
import Audience from '../components/stats/Audience'
import Chats from '../components/stats/Chats'
import Analyse from '../components/stats/analyse'
import Graph from '../components/stats/graph'
import ChatbotAI from '../components/stats/ChatbotAI'
import AgentsPerformance from '../components/stats/AgentsPerformance'
import C2C from '../components/stats/C2C'
import Visio from '../components/stats/Visio'
import Sales from '../components/stats/Sales'
import Leads from '../components/stats/Leads'
import Satisfaction from '../components/stats/Satisfaction'
import ViewCSV from '../components/stats/ViewCSV'
import Management from '../components/Management'
import Agents from '../components/management/Agents'
import Sites from '../components/management/Sites'
import Mapping from '../components/management/Mapping'
import Settings from '../components/Settings'
import Preview from '../components/settings/Preview'
import Absence from '../components/settings/Absence'
import Chat from '../components/settings/Chat'
import Callback from '../components/settings/Callback'
import Webcall from '../components/settings/Webcall'
import Visioconf from '../components/settings/Visioconf'
import Sms from '../components/settings/Sms'
import Bot from '../components/settings/ChatBot'
import Ecomm from '../components/settings/Ecomm'
import Connectors from '../components/settings/Connectors'
import BluePush from '../components/settings/BluePush'
import Recall from '../components/settings/Recall'
import Media from '../components/Media'
import Botbuilder from '../components/Botbuilder'
import Biblios from '../components/media/Biblios'
import Biblio from '../components/media/Biblio'
import SubBiblio from '../components/media/SubBiblio'

import OpenAIConfig from '../components/botbuilder/openAIConfig'
import Ticketing from '../components/Ticketing'
import Freshdesk from '../components/ticketing/Freshdesk'
import Zendesk from '../components/ticketing/Zendesk'
import Profile from '../components/Profile'
import Account from '../components/Account'
import csvExport from '../components/stats/csvExport'
import {
  ALL_ACCESS,
  NO_ADMINS, // 3
  NO_PEONS, // 0
  NO_AGENTS, // 1
  NO_PEONS_NOR_AGENTS, // 0, 1
  NO_PEONS_NO_AGENTS_NO_SUPER, // 0, 1, 2
  NO_PEONS_NO_AGENTS_NO_ADMINS_NO_SUPER, // 0, 1, 2, 3
  // NO_PEONS_NO_AGENTS_NO_ADMINS, // 0, 1, 3
  NO_PEONS_NO_ADMINS, // 0, 3
  LEVEL
} from '../constants'
Vue.use(Router)
const router = new Router({
  mode: 'hash',
  base: 'watcheezy',
  routes: [
    /**
     * Login
     */
    {
      path: '/login',
      name: 'login',
      component: Login,
      props: (route) => ({ directChat: route.query.directChat })
    },
    /**
     * Pour afficher les données trop grosses
     */
    {
      path: 'csvexport',
      name: 'csvexport',
      component: csvExport,
      meta: { permissions: { roles: NO_PEONS } }
    },
    /**
     * Ouvre directement un chat en pwa
     */
    {
      path: '/openchat',
      name: 'openchat',
      component: Attente
    },
    /**
     * Dash
     */
    {
      path: '/',
      component: Dash,
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          component: Dashboard
        },
        // le trafic
        {
          path: '/trafic',
          name: 'trafic',
          component: Trafic,
          meta: {
            tabs: [
              {
                title: 'visitors',
                to: '/trafic/visitors',
                roles: 'NO_ADMINS',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO, LEVEL.FAQ]
              },
              {
                title: 'chatting',
                to: '/trafic/chatting',
                roles: 'NO_ADMINS',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO, LEVEL.FAQ]
              },
              {
                title: 'attente',
                to: '/trafic/attente',
                roles: 'NO_PEONS_NO_ADMINS',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO, LEVEL.FAQ]
              },
              {
                title: 'monitoring',
                to: '/trafic/monitoring',
                roles: 'NO_PEONS_NOR_AGENTS',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO, LEVEL.FAQ]
              },
              {
                title: 'contact',
                to: '/trafic/contact',
                roles: 'NO_PEONS_NOR_AGENTS',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO, LEVEL.FAQ]
              }
            ]
          },
          children: [
            {
              path: 'visitors',
              name: 'visitors',
              component: Visitors,
              meta: {
                permissions: {
                  roles: NO_ADMINS
                }
              }
            },
            {
              path: 'chatting',
              name: 'chatting',
              component: Chatting,
              meta: {
                permissions: {
                  roles: NO_ADMINS
                }
              }
            },
            {
              path: 'monitoring',
              name: 'monitoring',
              component: Monitoring,
              meta: {
                permissions: {
                  roles: NO_PEONS_NOR_AGENTS
                }
              }
            },
            {
              path: 'attente',
              name: 'attente',
              component: Attente,
              meta: {
                permissions: {
                  roles: NO_PEONS_NO_ADMINS
                }
              }
            },
            {
              path: 'contact',
              name: 'contact',
              component: Contact,
              meta: {
                permissions: {
                  roles: NO_PEONS_NOR_AGENTS
                }
              }
            },
            {
              path: 'attente/:id',
              name: 'attenteOpenchat',
              component: Attente,
              meta: {
                permissions: {
                  roles: NO_PEONS_NOR_AGENTS
                }
              }
            }
          ]
        },
        // les stats
        {
          path: '/stats',
          name: 'stats',
          component: Stats,
          meta: {
            tabs: [
              {
                title: 'audience',
                to: '/stats/audience',
                roles: 'NO_PEONS',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO, LEVEL.FAQ]
              },
              {
                title: 'analyse',
                to: '/stats/analyse',
                roles: 'NO_PEONS', // le temps du test sinon repasser en NO_PEONS
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO]
              },
              {
                title: 'graph',
                to: '/stats/graph',
                roles: 'NO_PEONS', // le temps du test sinon repasser en NO_PEONS
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO]
              },
              {
                title: 'chats',
                to: '/stats/chats',
                roles: 'NO_PEONS',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO]
              },
              {
                title: 'IA',
                to: '/stats/chatbotai',
                roles: 'NO_PEONS_NOR_AGENTS',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO, LEVEL.FAQ]
              },
              { title: 'agents',
                to: '/stats/agents-perf',
                roles: 'NO_PEONS_NOR_AGENTS',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO]
              },
              { title: 'C2C',
                to: '/stats/C2C',
                roles: 'NO_PEONS_NOR_AGENTS',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO]
              },
              { title: 'Visio',
                to: '/stats/Visio',
                roles: 'NO_PEONS_NOR_AGENTS',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO]
              },
              { title: 'sales',
                to: '/stats/sales',
                roles: 'NO_PEONS_NOR_AGENTS',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO]
              },
              { title: 'leads',
                to: '/stats/leads',
                roles: 'NO_PEONS_NOR_AGENTS',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO]
              },
              { title: 'satisfaction',
                to: '/stats/satisfaction',
                roles: 'NO_PEONS_NOR_AGENTS',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO, LEVEL.FAQ]
              }
            ]
          },
          children: [
            {
              path: 'audience',
              name: 'audience',
              component: Audience,
              meta: {
                permissions: {
                  roles: NO_PEONS
                }
              }
            },
            {
              path: 'chats',
              name: 'chats',
              component: Chats,
              meta: {
                permissions: {
                  roles: NO_PEONS
                }
              }
            },
            {
              path: 'analyse',
              name: 'analyse',
              component: Analyse,
              meta: {
                permissions: {
                  roles: NO_PEONS_NO_AGENTS_NO_SUPER
                }
              }
            },
            {
              path: 'graph',
              name: 'graph',
              component: Graph,
              meta: {
                permissions: {
                  roles: NO_PEONS_NO_AGENTS_NO_SUPER
                }
              }
            },
            {
              path: 'chatbotai',
              name: 'chatbotai',
              component: ChatbotAI,
              meta: {
                permissions: {
                  roles: NO_PEONS_NOR_AGENTS
                }
              }
            },
            {
              path: 'viewcsv',
              name: 'viewcsv',
              component: ViewCSV,
              meta: {
                permissions: {
                  roles: NO_PEONS_NOR_AGENTS
                }
              }
            },
            {
              path: 'agents-perf',
              name: 'agents-perf',
              meta: {
                title: 'agents',
                permissions: {
                  roles: NO_PEONS_NOR_AGENTS
                }
              },
              component: AgentsPerformance
            },
            {
              path: 'C2C',
              name: 'C2C',
              component: C2C,
              meta: {
                permissions: {
                  roles: NO_PEONS_NOR_AGENTS
                }
              }
            },
            {
              path: 'Visio',
              name: 'Visio',
              component: Visio,
              meta: {
                permissions: {
                  roles: NO_PEONS_NOR_AGENTS
                }
              }
            },
            {
              path: 'sales',
              name: 'sales',
              component: Sales,
              meta: {
                permissions: {
                  roles: NO_PEONS_NOR_AGENTS
                }
              }
            },
            {
              path: 'leads',
              name: 'leads',
              component: Leads,
              meta: {
                permissions: {
                  roles: NO_PEONS_NOR_AGENTS
                }
              }
            },
            {
              path: 'satisfaction',
              name: 'satisfaction',
              component: Satisfaction,
              meta: {
                permissions: {
                  roles: NO_PEONS_NOR_AGENTS
                }
              }
            }
          ]
        },
        // management
        {
          path: '/management',
          name: 'management',
          component: Management,
          meta: {
            tabs: [
              {
                title: 'agents',
                to: '/management/agents',
                roles: 'NO_PEONS_NOR_AGENTS',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO, LEVEL.FAQ]
              },
              {
                title: 'sites',
                to: '/management/sites',
                roles: 'NO_PEONS_NOR_AGENTS',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO]
              },
              {
                title: 'mapping',
                to: '/management/mapping',
                roles: 'NO_PEONS_NOR_AGENTS',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO]
              }
              // { title: 'groupe', to: '/management/group' }
            ]
          },
          children: [
            {
              path: 'agents',
              name: 'agents',
              component: Agents,
              meta: {
                permissions: {
                  roles: NO_PEONS_NOR_AGENTS
                }
              }
            },
            {
              path: 'sites',
              name: 'sites',
              component: Sites,
              meta: {
                permissions: {
                  roles: NO_PEONS_NOR_AGENTS
                }
              }
            },
            {
              path: 'mapping',
              name: 'mapping',
              component: Mapping,
              meta: {
                permissions: {
                  roles: NO_PEONS_NOR_AGENTS
                }
              }
            }
            // {
            // path: 'group',
            // name: 'group',
            // component: Group,
            // meta: { permissions: { roles: NO_PEONS_NOR_AGENTS } }
            // }
          ]
        },
        // settings
        {
          path: '/settings',
          name: 'settings',
          component: Settings,
          meta: {
            tabs: [
              {
                title: 'preview',
                to: '/settings/preview',
                roles: 'ALL_ACCESS',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO, LEVEL.FAQ]
              },
              {
                title: 'routeurOffline',
                to: '/settings/absence',
                roles: 'NO_PEONS',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO]
              },
              {
                title: 'routeurOnline',
                to: '/settings/chat',
                roles: 'NO_PEONS_NOR_AGENTS',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO]
              },
              {
                title: 'widget + chatbot',
                to: '/settings/bot',
                roles: 'NO_PEONS_NOR_AGENTS',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO, LEVEL.FAQ]
              },
              {
                title: 'callback',
                to: '/settings/callback',
                roles: 'NO_PEONS_NO_AGENTS_NO_SUPER',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO]
              },
              {
                title: 'meeting',
                to: '/settings/recall',
                roles: 'NO_PEONS_NO_AGENTS_NO_SUPER',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO]
              },
              {
                title: 'webcall',
                to: '/settings/webcall',
                roles: 'NO_PEONS_NO_AGENTS_NO_SUPER',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO]
              },
              {
                title: 'Visioconf',
                to: '/settings/visioconf',
                roles: 'NO_PEONS_NO_AGENTS_NO_SUPER',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO]
              },
              // { title: 'planning', to: '/settings/planning', brideName: 'parametre_planning' },
              {
                title: 'sms',
                to: '/settings/sms',
                roles: 'NO_PEONS_NO_AGENTS_NO_SUPER',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO]
              },
              // { title: 'cobrowsing', to: '/settings/cobrowsing', brideName: 'parametre_cobrowsing' },
              {
                title: 'ecomm',
                to: '/settings/ecomm',
                roles: 'NO_PEONS_NO_AGENTS_NO_SUPER',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO]
              },
              {
                title: 'connectors',
                to: '/settings/connectors',
                roles: 'NO_PEONS_NO_AGENTS_NO_SUPER',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO]
              },
              {
                title: 'bluepush',
                to: '/settings/bluepush',
                roles: 'NO_PEONS_NO_AGENTS_NO_SUPER',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO]
              }
              // { title: 'analytics', to: '/settings/analytics', brideName: 'parametre_analytics' }
              // { title: 'notifications', to: '/settings/notifications' }
            ]
          },
          children: [
            {
              path: 'preview',
              name: 'preview',
              component: Preview,
              meta: {
                permissions: {
                  roles: ALL_ACCESS
                } // NO_AGENTS
              }
            },
            {
              path: 'absence',
              name: 'absence',
              component: Absence,
              meta: {
                permissions: {
                  roles: NO_PEONS
                }
              }
            },
            {
              path: 'chat',
              name: 'chat',
              component: Chat,
              meta: {
                permissions: {
                  roles: NO_PEONS_NOR_AGENTS
                }
              }
            },
            {
              path: 'bot',
              name: 'bot',
              component: Bot,
              meta: {
                permissions: {
                  roles: NO_PEONS_NOR_AGENTS
                }
              }
            },
            {
              path: 'callback',
              name: 'callback',
              component: Callback,
              meta: {
                permissions: {
                  roles: NO_PEONS_NO_AGENTS_NO_SUPER
                }
              }
            },
            {
              path: 'recall',
              name: 'meeting',
              component: Recall,
              meta: {
                permissions: {
                  roles: NO_PEONS_NO_AGENTS_NO_SUPER
                }
              }
            },
            {
              path: 'webcall',
              name: 'webcallback rtc',
              component: Webcall,
              meta: {
                permissions: {
                  roles: NO_PEONS_NO_AGENTS_NO_SUPER
                }
              }
            },
            {
              path: 'visioconf',
              name: 'visioconf',
              component: Visioconf,
              meta: {
                permissions: {
                  roles: NO_PEONS_NO_AGENTS_NO_SUPER
                }
              }
            },
            /* {
              path: 'planning',
              name: 'planning',
              component: Planning,
              meta: {
                permissions: { roles: NO_PEONS_NOR_AGENTS }
              }
            }, */
            {
              path: 'sms',
              name: 'sms',
              component: Sms,
              meta: {
                permissions: {
                  roles: NO_PEONS_NO_AGENTS_NO_SUPER
                }
              }
            },
            /* {
              path: 'cobrowsing',
              name: 'cobrowsing',
              component: Cobrowsing,
              meta: {
                permissions: { roles: NO_PEONS_NOR_AGENTS }
              }
            }, */
            {
              path: 'ecomm',
              name: 'ecomm',
              component: Ecomm,
              meta: {
                permissions: {
                  roles: NO_PEONS_NO_AGENTS_NO_SUPER
                }
              }
            },
            {
              path: 'connectors',
              name: 'connectors',
              component: Connectors,
              meta: {
                permissions: {
                  roles: NO_PEONS_NO_AGENTS_NO_SUPER
                }
              }
            },
            {
              path: 'bluepush',
              name: 'bluepush',
              component: BluePush,
              meta: {
                permissions: {
                  roles: NO_PEONS_NO_AGENTS_NO_SUPER
                }
              }
            }
            /*
            {
              path: 'analytics',
              name: 'analytics',
              component: Analytics,
              meta: {
                permissions: { roles: NO_PEONS_NOR_AGENTS }
              }
            },
            {
              path: 'notifications',
              name: 'notifications',
              component: Notifications,
              meta: { permissions: { roles: NO_PEONS_NOR_AGENTS } }
            } */
          ]
        },
        // media
        {
          path: '/media',
          name: 'media',
          component: Media,
          meta: {
            tabs: [
              {
                title: 'quickSentences',
                to: '/media/biblios',
                roles: 'NO_PEONS'
              }
            ]
          },
          children: [
            {
              path: 'biblios',
              name: 'biblios',
              component: Biblios,
              meta: {
                permissions: {
                  roles: NO_PEONS
                }
              }
            },
            {
              path: 'biblios/:id',
              component: Biblio,
              meta: {
                back: '/media/biblios',
                tabs: null,
                permissions: {
                  roles: NO_PEONS
                }
              },
              props: true
            },
            {
              path: 'biblios/:idParent/sub/:idSub',
              component: SubBiblio,
              meta: {
                back: '/media/biblios/:idParent',
                tabs: null,
                permissions: {
                  roles: NO_PEONS
                }
              },
              props: true
            }
          ]
        },
        // bot builder
        {
          path: '/botbuilder',
          name: 'botbuilder',
          component: Botbuilder,
          meta: {
            tabs: [
              {
                title: 'OpenAIConfig',
                to: '/botbuilder/openAIConfig',
                roles: 'NO_PEONS_NOR_AGENTS',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO, LEVEL.FAQ]
              }
            ]
          },
          children: [
            {
              path: 'OpenAIConfig',
              name: 'OpenAIConfig',
              component: OpenAIConfig,
              meta: {
                permissions: {
                  roles: NO_PEONS_NOR_AGENTS
                }
              }
            }
          ]
        },
        // ticketing
        {
          path: '/ticketing',
          name: 'Ticketing',
          component: Ticketing,
          meta: {
            tabs: [
              {
                title: 'Freshdesk',
                to: '/ticketing/freshdesk',
                roles: 'NO_PEONS',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO]
              },
              {
                title: 'Zendesk',
                to: '/ticketing/zendesk',
                roles: 'NO_PEONS',
                levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE, LEVEL.CHAT, LEVEL.START, LEVEL.PRO]
              }
            ]
          },
          children: [
            {
              path: 'freshdesk',
              name: 'Freshdesk',
              component: Freshdesk,
              meta: {
                permissions: {roles: NO_PEONS}
              }
            },
            {
              path: 'zendesk',
              name: 'Zendesk',
              component: Zendesk,
              meta: {
                permissions: {roles: NO_PEONS}
              }
            }
          ]
        },
        // profile
        {
          path: 'profile',
          name: 'profile',
          component: Profile
        },
        // compte
        {
          path: 'account',
          name: 'account',
          component: Account,
          meta: { permissions: { roles: NO_PEONS_NOR_AGENTS } }
        }
      ]
    },
    {
      path: '*',
      redirect: '/stats/audience'
    }
  ]
})
/**
 * Avant chaque accès à une nouvelle route
 * @param   {Router}    (to, from)  Router pris en charge, route de départ et route d'arrivée
 * @param   {Function}  next        se rend au router d'arrivée
 */
router.beforeEach(async (to, from, next) => {
  var checkPermission = function (roles) {
    if (roles === 'NO_ADMINS') {
      return (_.indexOf(NO_ADMINS, store.getters['_User/account'].role) !== -1)
    } else if (roles === 'NO_AGENTS') {
      return (_.indexOf(NO_AGENTS, store.getters['_User/account'].role) !== -1)
    } else if (roles === 'NO_PEONS') {
      return (_.indexOf(NO_PEONS, store.getters['_User/account'].role) !== -1)
    } else if (roles === 'NO_PEONS_NOR_AGENTS') {
      return (_.indexOf(NO_PEONS_NOR_AGENTS, store.getters['_User/account'].role) !== -1)
    } else if (roles === 'NO_PEONS_NO_AGENTS_NO_SUPER') {
      return (_.indexOf(NO_PEONS_NO_AGENTS_NO_SUPER, store.getters['_User/account'].role) !== -1)
    } else if (roles === 'NO_PEONS_NO_AGENTS_NO_ADMINS_NO_SUPER') {
      return (_.indexOf(NO_PEONS_NO_AGENTS_NO_ADMINS_NO_SUPER, store.getters['_User/account'].role) !== -1)
    } else if (roles === 'NO_PEONS_NO_ADMINS') {
      return (_.indexOf(NO_PEONS_NO_ADMINS, store.getters['_User/account'].role) !== -1)
    } else if (roles === 'ALL_ACCESS') {
      return (_.indexOf(ALL_ACCESS, store.getters['_User/account'].role) !== -1)
    }
  }
  // var checkLevel = function (levels) {
  //   console.warn('levels :', levels)
  //   let i = 0
  //   for (let level of levels) {
  //     // console.log('level', level)
  //     if (level === store.getters['_User/level'].rights) {
  //       i++
  //     } else {
  //       console.warn('levels est indéfini ou n\'est pas un tableau :', levels)
  //     }
  //   }
  //   return i
  // }

  if (to.query.directChat) {
    sessionStorage.setItem('tf-directChat', to.query.directChat)
  }
  let _User = {
    account: store.getters['_User/account'],
    level: store.getters['_User/level'],
    entId: store.state._User.entId,
    hideTabVisitors: store.state._User.hideTabVisitors,
    brides: store.state._User.brides,
    isMobile: store.state._User.isMobile,
    connexionType: store.state._User.connexionType,
    ketb: store.state._User.ketb
  }
  /**
   * gestion de la route en fonction de :
   * - l'état de la connection de l'utilisateur
   * - la licence
   */
  let connected = store.getters.logged

  if (!connected) {
    if (to.path !== '/login') {
      router.push({ path: '/login' })
      next(false)
    } else {
      next(true)
    }
    return
  } else if (connected) {
    if (!_User.level) {
      // store.commit('logout')
      console.log('[router index] logout ')
      store.dispatch('_StoreWatcheeBox/removeAllChatsSession', this.$socket) // vuex action
    } else if (to.path === '/' || to.path === '/login') {
      if (_User.account.role === 'peon') {
        router.push({ path: '/trafic/visitors' })
      } else {
        if (_User.isMobile) {
          // uniquement pour reshdesk mobile
          if (_User.connexionType === 'freshdesk') {
            // il faut deconnecter le client freshdesk pour bien le reconnecter automatiquement
            store.commit('logoutFreshdesk')
          // pour le reste sur mobile
          } else {
            router.push({ path: '/trafic/visitors' })
          }
        } else {
          // uniquement pour reshdesk
          if (_User.connexionType === 'freshdesk') {
            // il faut deconnecter le client freshdesk pour bien le reconnecter automatiquement
            store.commit('logoutFreshdesk')
          // pour le reste
          } else {
            router.push({ path: '/stats/audience' })
          }
        }
      }
    }
  }
  // if (to.meta.brideName) {
  //   // let brideStatus = _User.brides.find(a => a.brideName === 'parametre_chat')
  //   let brideStatus = _.find(_User.brides, function (o) { return o.brideName === to.meta.brideName })
  //   console.log('brideName', brideStatus)
  //   // console.log('brideName', _User.brides.brideName)
  // }

  // dans le cas où il faut une permission pour accéder à cette route
  // vérification des droits
  let permission = true
  let because = null
  if (to.meta.permissions) {
    // test de la présence du role du user dans la liste des permissions de la route
    permission =
      !to.meta.permissions.roles ||
      (to.meta.permissions.roles &&
        _.indexOf(to.meta.permissions.roles, _User.account.role) !== -1)
    because = permission ? null : 'account'
    // console.log('because role :', because)

    // et de la licence si permission
    // sinon pas la peine d'aller plus loin
    // console.log('permission :', permission)

    // console.log('to.meta.permissions.levels :', to.meta.permissions.levels)
    permission =
      !to.meta.permissions.levels ||
      (to.meta.permissions.levels &&
        _.indexOf(to.meta.permissions.levels, _User.level.rights) !== -1)
    because = permission ? null : 'level'
    // console.log('because level :', because)

    // ------------------------------------------------------------------------------------
    // Brides
    // interdiction d'acceder à cette page si status = 0
    // if (_User.brides) {
    //   // console.log('_User.brides', _User.brides)
    //   let brideStatus = _User.brides.find(function (o) {
    //     return o.brideName === to.meta.brideName
    //   })
    //   // console.log('brideStatus', brideStatus)
    //   if (brideStatus) {
    //     if (brideStatus.status === '0') {
    //       permission = false
    //     }
    //   }
    // }
  }
  // console.log('permission :', permission)
  if (permission) {
    // console.log('change de route', to.meta.tabs)
    /**
     * MAJ onglets
     */
    // vide les onglets si la route spécifie explicitement
    // qu'elle n'a pas d'onglets (tabs à null)
    // exemple: route avec la flèche de retour
    let updateTabs = !_.isNull(to.meta.tabs)
    if (!updateTabs) {
      // vide le système d'onglets
      // store.commit('_Toolbar/SET_TABS', [])
    } else if (to.matched.some(route => route.meta.tabs)) {
      // test si une autre route identique possède des onglets
      // recherche parmis les routes qui matchent, la liste des onglets qu'il faut récupérer
      let tabs = _.find(to.matched, route => {
        return route.meta.tabs
      })
      tabs = tabs.meta.tabs
      // ------------------------------------------------------------------------------------
      // check si l'agent est autorisé à voir la section de ce menu
      // console.log('_User.brides', _User.brides)
      let i
      for (i = tabs.length - 1; i >= 0; i -= 1) {
      // tabs.forEach(function (element, index) {
        // if (tabs[i].brideName) {
        //   // console.log('tabs[i].brideName ' + tabs[i].brideName + ' : ' + tabs[i].roles)
        //   // console.log('checkPermission', checkPermission(tabs[i].roles))
        //   // regarde si un bride est  appliqué à cette section dans le menu
        //   if (_User.brides) {
        //     let brideStatus = _.find(_User.brides, function (o) { return o.brideName === tabs[i].brideName })
        //     // console.log('brideStatus', brideStatus)
        //     tabs[i].status = brideStatus.status
        //     // si il n'est pas autorisé à voir cette section
        //     // if (brideStatus.status === '0') {
        //     //   // on l'efface du menu
        //     //   if (_User.ketb === 1) {
        //     //     tabs.splice(i, 1)
        //     //   }
        //     // }
        //   }
        //   // efface ici les sous menu dont on a pas acces
        //   // console.log('tabs[i].levels', tabs[i].levels)
        //   // if (!checkPermission(tabs[i].roles)) {
        //   //   tabs.splice(i, 1)
        //   // }
        // }
        if (!checkPermission(tabs[i].roles)) {
          console.log('pas de permission')
          tabs.splice(i, 1)
        }
      }
      let newTabs = tabs
      // console.log('tabs', tabs)
      // console.log('_User.account.role', _User.account.role)
      // -------------------------------------------------------------------------------------
      // en fonction de la permission
      newTabs = _.filter(newTabs, t => {
        // Si pas d'onglet visitors
        if (_User.hideTabVisitors) {
          if (t.title !== 'visitors') {
            return t
          }
          return
        }
        // retire le nom de la tab menu
        if (_User.account.role === 'agent' || _User.account.role === 'peon') {
          if (t.title !== 'monitoring' && t.title !== 'contact') {
            return t
          }
        } else if (_User.account.role === 'admin') {
          if (t.title !== 'visitors' && t.title !== 'chatting' && t.title !== 'contact') {
            return t
          }
        } else if (_User.isMobile) {
          if (t.title !== 'monitoring' && t.title !== 'contact') {
            return t
          }
        } else {
          return t
        }
      })
      store.commit('_Toolbar/SET_TABS', newTabs)
    } else {
      // vide le système d'onglets
      // store.commit('_Toolbar/SET_TABS', [])
    }
    /**
     * MAJ du titre de la toolbar
     */
    let title = to.fullPath
    // suppression de l'id dans le chemin, si présent
    // if (!_.isEmpty(to.params.id)) {
    //   let paths = to.fullPath.split('/')
    //   title = ''
    //   for (var i = 0; i < paths.length - 1; i++) {
    //     title += paths[i]
    //     if (i !== paths.length - 2) {
    //       title += '/'
    //     }
    //   }
    // }
    // si un title est spécifié explicitement pour la vue
    title = to.meta.title
      ? '/' + title.split('/')[1] + '/' + to.meta.title
      : title
    store.commit('_Toolbar/SET_TITLE', title.substring(1).split('/')[0])
    /**
     * MAJ flèche de retour
     */
    to.meta.back
      ? store.commit('_Toolbar/SET_BACK', to.meta.back)
      : store.commit('_Toolbar/SET_BACK', null) // efface la flèche de retour
    /**
     * MAJ du sous-titre de la toolbar se fera dans le composant directement
     */
    if (to.meta.back) {
      store.commit('_Toolbar/SET_SUB_TITLE', null)
    }
    /**
     * MAJ du visiteur focus si pas sur une page trafic
     * alors perte de focus, afin d'avoir les notifications
     */
    if (to.name !== 'trafic') {
      store.commit('_StoreWatcheeBox/AGENT_FOCUS', {
        view: 1,
        visiteurID: 1
      })
    }
    next()
    // vide le tableau des notifications
    store.commit('_Notifier/CLEAR')
  } else {
    // si pas de permission alors pas de changement de route
    // et notification du manque de permission
    next(false)
    // let path = t.messages[t.locale][to.path.split('/')[1]] || to.path.split('/')[1]
    store.dispatch('_Notifier/NEW_NOTIF', {
      // message: `En tant que ` + _User.account.type + `, vous ne pouvez accéder à la section : '` + path + `'`,
      message:
        because === 'account'
          ? `En tant que ` +
            _User.account.type +
            `, vous ne pouvez accéder à cette section`
          : `Votre licence actuelle ne vous ne permet pas d'accéder à cette section`,
      multiLine: true,
      context: 'error',
      position: 'top'
    })
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js